import { PayloadAction, createSlice } from '@reduxjs/toolkit'

import { ApiResponseSerializer } from 'src/v2/commons/interface/ApiResponseSerializer'

export const defaultUsers: ApiResponseSerializer<any> = {
  records: [],
  totalRecords: 0,
  recordsLeft: 0,
}

const initialState = {
  ...defaultUsers,
}

const usersStore = createSlice({
  name: 'users',
  initialState,
  reducers: {
    setUsers: (state, action: PayloadAction<ApiResponseSerializer<any>>) => {
      state = {
        ...action.payload,
      }
    },
    resetUserSessionStore: (state) => {
      state = { ...initialState }
    },
  },
})

export const { setUsers, resetUserSessionStore } = usersStore.actions
export default usersStore.reducer
